var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center"},_vm._l((_vm.selectedColors),function(item,index){return _c('style-manager-editor',{key:'color-' + index,attrs:{"currentColor":item,"colorKey":index,"colorName":_vm.colorNames[index]},on:{"update:currentColor":_vm.applyChanges}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }